import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import THEME from 'theme';
import { TextSmall } from 'components/chroma/extended';

const Wrapper = styled.div`
  background-color: ${THEME.LINK.DEFAULT};
  border-radius: 1.75rem;
  padding: 0.5rem;
  margin: 0.1rem;
  text-align: center;
  :focus-within {
    background-color: ${THEME.BACKGROUND.FOCUS};
    outline: 2px solid ${THEME.BACKGROUND.DARK};
  }
  a,
  a:hover,
  a:focus,
  a:active {
    text-decoration: none;
  }
  .c-text {
    color: ${THEME.TEXT.WHITE} !important;
  }
`;

export const LinkButtonPrimary: FunctionComponent<{
  label: string;
  ariaLabel: string;
  url: string;
}> = ({ label, ariaLabel, url }) => (
  <Wrapper>
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={ariaLabel}
    >
      <TextSmall margin={{ bottom: 0 }}>{label}</TextSmall>
    </a>
  </Wrapper>
);

export default LinkButtonPrimary;
